export default __webpack_public_path__ + "static/media/set_2_Page-1.a3231526.svg";